import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant from '../../../Constant.js'
import axios from 'axios'
import MUIDataTable from 'mui-datatables'
import Loader from '../../../common/Loader.js'
import CustomFooter from '../../../common/TableBottom.js'
import Moment from 'react-moment'
import Modal from 'react-responsive-modal'
import WithdrawModel from '../../Booking/Withdraw.js'
import CheckPermission from '../../../common/Permissions/CheckPermission.js'
import moment from 'moment'
import Button from '../../../common/CustomComponents/Button.js'
class WalletHistory extends React.Component {
  state = {
    isLoading: false,

    listCountries: [],
    walletHistoryList: [],

    country: localStorage.getItem('countryShortName') || 'KWT',
    limit: 10,
    pageNumber: 0,

    totalPages: 0,
    disabled: false,
    withdrawalModal: false,
  }

  componentDidMount() {
    if (this.props.customer_id) {
      this.getWalletHistory()
    }
  }

  async getWalletHistory() {
    this.setState({ isLoading: true })

    await axios
      .get(Constant.getAPI() + '/user/wallet-history/', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: {
          user_id: this.props.customer_id,
          limit: this.state.limit,
          pageNumber: this.state.pageNumber,
          country: this.state.country,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            walletHistoryList: res?.data?.data?.history || [],
            walletAmount: res?.data?.data?.walletAmount || 0,
            currency: res?.data?.data?.currency || 'KWD',
            nonExpirableWalletAmount:
              res?.data?.data?.walletAmount - res?.data?.data?.wallet_data?.expirable_wallet_total,
            expirableWalletAmount: res?.data?.data?.wallet_data?.expirable_wallet_total,

            totalPages: res.data?.pagination?.pages,
            disabled: this.state.pageNumber + 1 >= res.data?.pagination?.pages,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({ isLoading: false })
      })
  }

  showDetails = (id) => {
    const bookingData = this.state?.walletHistoryList?.find((ele) => ele.id === id)
    if (bookingData?.details?.walletPayment?.length > 0) {
      const content = `
    <div>
      <table style="width:100%">
        <tbody>
          <tr>
            <th></th>
            ${bookingData?.details?.walletPayment.map((item, index) => `<th style="text-align: left">Payment ${index + 1}</th>`)}
          </tr>
          <tr>
            <th>Payment ID</th>
            ${bookingData?.details?.walletPayment.map((item) => `<td style="text-align: left">${item.payment_id || '--'}</td>`)}
          </tr>
          <tr>
            <th>Payment Status</th>
            ${bookingData?.details?.walletPayment.map((item) => '<td style="text-align: left">' + (item.payment_status || '--') + '</td>')}
          </tr>
          <tr>
            <th>Payment Method</th>
            ${bookingData?.details?.walletPayment.map((item) => '<td style="text-align: left">' + (item?.payment_method?.PaymentMethod_en || '--') + '</td>')}
          </tr>
          <tr>
            <th>Payment Amount</th>
            ${bookingData?.details?.walletPayment.map((item) => '<td style="text-align: left">' + (item.payment_currency || this.state.currency) + ' ' + item.payment_amount + '</td>')}
          </tr>
          <tr>
            <th>Transaction ID</th>
            ${bookingData?.details?.walletPayment.map((item) => '<td style="text-align: left">' + (item.txn_id || '--') + '</td>')}
          </tr>
          <tr>
            <th>Invoice Reference ID</th>
            ${bookingData?.details?.walletPayment.map((item) => '<td style="text-align: left">' + (item.payment_info.InvoiceReference || '--') + '</td>')}
          </tr>
        </tbody>
      </table>
    </div>
`
      Swal.fire({
        width: '1000px',
        title: '<strong>Payment Details</strong>',
        html: content,
      })
    } else {
      Swal.fire({
        title: '<strong>Payment Details Not Found</strong>',
        icon: 'error',
        type: 'error',
      })
    }
  }

  handleOnClick() {
    this.setState({
      withdrawalModal: true,
    })
  }

  processWithdrawal = async (state) => {
    this.setState({
      withdrawalModal: false,
    })
    const data = {
      user_id: this.props.customer_id,
      amount: state?.amount,
      comment_en: `Amount of ${state?.amount} withdraw to user account - ${state?.comment}`,
      comment_ar: `كمية ${state?.amount} الانسحاب إلى حساب المستخدم`,
    }

    await axios
      .post(Constant.getAPI() + '/admin/wallet-withdraw', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Success !', 'Withdraw Processed', 'success')
          this.getWalletHistory()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getStatusOfValue = (id) => {
    let dataSet = this.state.walletHistoryList.find((data) => data.id == id)
    if (dataSet) {
      if (dataSet.type == 'REDV' || dataSet.type == 'ADD') {
        return <span style={{ color: 'green' }}> (Real)</span>
      } else if (dataSet.type == 'RWD') {
        if (dataSet.is_redeemed == 1) {
          return <span style={{ color: 'Green' }}> (Expirable & Used)</span>
        } else if (dataSet.expired_at && moment(dataSet.expired_at).isBefore(moment())) {
          return <span style={{ color: 'red' }}> (Expired)</span>
        } else {
          return <span style={{ color: 'red' }}> (Expirable)</span>
        }
      } else if (dataSet.type == 'REF') {
        if (dataSet.is_redeemed == 1) {
          return <span style={{ color: 'Green' }}> (Used)</span>
        } else {
          if (dataSet.expired_at == null) {
            return <span style={{ color: 'green' }}> (Real)</span>
          } else if (dataSet.expired_at && moment(dataSet.expired_at).isBefore(moment())) {
            return <span style={{ color: 'red' }}> (Expired)</span>
          } else {
            return <span style={{ color: 'red' }}> (Expirable)</span>
          }
        }
      }
    }

    return ''
  }

  render() {
    const columns = [
      {
        name: 'id',
        label: 'id',
        options: {
          display: false,
        },
      },
      {
        name: 'img',
        label: 'Type',
        options: {
          customBodyRender: (value) => {
            return (
              <>
                <img
                  src={Constant.getImage() + value}
                  className="img-fluid img-50"
                  alt="img"
                  onError={(event) => {
                    event.currentTarget.src = './assets/images/no_image.png'
                  }}
                  style={{ borderRadius: 25 }}
                />
              </>
            )
          },
        },
      },
      {
        name: 'type',
        label: 'Action Type',
        options: {
          customBodyRender: (data, tableMeta) => {
            return (
              <div style={{ textWrap: 'nowrap' }}>
                {data == 'ADD' && 'Wallet Recharge'}
                {data == 'REF' && 'Refund'}
                {data == 'SUB' && tableMeta.rowData[3] == 'WT' && 'Withdrawal'}
                {data == 'SUB' && tableMeta.rowData[3] != 'WT' && 'Spent on Booking'}
                {data == 'REDV' && 'Redeem Voucher'}
                {data == 'RWD' && 'Reword'}
              </div>
            )
          },
        },
      },
      {
        name: 'transaction_type',
        label: 'Transaction Type',
        options: {
          customBodyRender: (data) => {
            return (
              <div style={{ textWrap: 'nowrap' }}>
                {data == 'C' && 'Cruise Booking'}
                {data == 'E' && 'Event Booking'}
                {data == 'S' && 'Store Booking'}
                {data == 'CH' && 'Chalet Booking'}
                {data == 'V' && 'Recharge'}
                {data == 'PAY' && 'Recharge'}
                {data == 'WT' && 'Withdraw to Account'}
                {!data && '--'}
              </div>
            )
          },
        },
      },
      {
        name: 'details',
        label: 'Details',
        options: {
          customBodyRender: (data, tableMeta) => {
            return (
              <div style={{ textWrap: 'nowrap' }}>
                {tableMeta.rowData[3] == 'C' && (
                  <span>
                    Booking ID -{' '}
                    <Link
                      to={'/booking-ordering/' + data.id}
                      className="m-r-15 text-primary"
                    >
                      {data.order_number}
                    </Link>
                  </span>
                )}
                {tableMeta.rowData[3] == 'E' && (
                  <span>
                    Booking ID -{' '}
                    <Link
                      to={'/new-evt/' + data.id}
                      className="m-r-15 text-primary"
                    >
                      {data.order_number}
                    </Link>
                  </span>
                )}
                {tableMeta.rowData[3] == 'S' && (
                  <span>
                    Booking ID -{' '}
                    <Link
                      to={'/store-bookings-details/' + data.id}
                      className="m-r-15 text-primary"
                    >
                      {data.order_number}
                    </Link>
                  </span>
                )}
                {tableMeta.rowData[3] == 'CH' && (
                  <span>
                    Booking ID -{' '}
                    <Link
                      to={'/chalet-booking-details/' + data?.id}
                      className="m-r-15 text-primary"
                    >
                      {data?.order_number}
                    </Link>
                  </span>
                )}
                {tableMeta.rowData[3] == 'PAY' && '--'}
                {tableMeta.rowData[3] == 'V' && <span>{`Voucher Code - ${data?.code}`}</span>}
              </div>
            )
          },
        },
      },
      {
        name: 'amount',
        label: 'Amount',
        options: {
          customBodyRender: (data, tableMeta) => {
            return (
              <div style={{ textWrap: 'nowrap' }}>
                {data > 0 ? (
                  <span className="text-success font-weight-bold">{data}</span>
                ) : (
                  <span className="text-danger font-weight-bold">{data}</span>
                )}
                {tableMeta.rowData[0] && this.getStatusOfValue(tableMeta.rowData[0])}
              </div>
            )
          },
        },
      },
      {
        name: 'comment_en',
        label: 'Comment En',
        options: {
          customBodyRender: (data) => {
            return <div style={{ textWrap: 'nowrap' }}>{data || '--'}</div>
          },
        },
      },
      {
        name: 'comment_ar',
        label: 'Comment Ar',
        options: {
          customBodyRender: (data) => {
            return <div style={{ textWrap: 'nowrap' }}>{data || '--'}</div>
          },
        },
      },
      {
        name: 'created_at',
        label: 'Transaction Date',
        options: {
          customBodyRender: (data) => {
            return (
              <div style={{ textWrap: 'nowrap' }}>
                <Moment format="YYYY-MM-DD hh:mm:ss A">{data}</Moment>
              </div>
            )
          },
        },
      },
      {
        name: 'expired_at',
        label: 'Expiry Date',
        options: {
          customBodyRender: (data) => {
            return data ? (
              <div style={{ textWrap: 'nowrap' }}>
                <Moment format="YYYY-MM-DD hh:mm:ss A">{data}</Moment>
              </div>
            ) : (
              '--'
            )
          },
        },
      },
      {
        name: 'details',
        label: 'Payment Details',
        options: {
          customBodyRender: (data, tableMeta) => {
            const bookingData = this.state.walletHistoryList?.find((ele) => ele.id === tableMeta.rowData[0])

            return bookingData?.details?.walletPayment?.length > 0 ? (
              <img
                className="img-fluid m-l-5"
                src="./assets/images/info.png"
                alt="ico"
                style={{ width: 13 }}
                onClick={() => this.showDetails(tableMeta.rowData[0])}
              />
            ) : (
              '--'
            )
          },
        },
      },
    ]

    const options = {
      // filterType: "dropdown",
      viewColumns: false,
      print: false,
      download: false,
      filter: false,
      customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
        return (
          <CustomFooter
            count={this.state.limit}
            changePage={changePage}
            changeRowsPerPage={changeRowsPerPage}
            disabled={this.state.disabled}
            pageNumber={this.state.pageNumber}
            totalPages={this.state.totalPages}
          />
        )
      },
      onChangePage: (currentPage) => {
        this.setState(
          {
            pageNumber: currentPage,
            bookingList: [],
          },
          () => {
            this.getWalletHistory()
          }
        )
      },
      onChangeRowsPerPage: (numberOfRows) => {
        this.setState(
          {
            limit: numberOfRows,
            bookingList: [],
          },
          () => {
            this.getWalletHistory()
          }
        )
      },
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isLoading ? <Loader open={this.state.isLoading} /> : 'Sorry, No Booking Data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <>
        <div className="page-body">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-block">
                  <div className="row">
                    <div
                      className="col-8"
                      style={{ fontSize: 18 }}
                    >
                      {`Total Balance:- ${this.state.walletAmount || 0} ${this.state.currency || ''}`}
                      <br />
                      {`Expirable Balance:- ${this.state.expirableWalletAmount || 0} ${this.state.currency || ''}`}
                      <br />
                      {`Real Balance:- ${this.state.walletAmount - this.state.expirableWalletAmount || 0} ${this.state.currency || ''}`}
                    </div>
                    <div className="col-4 float-right text-right">
                      <CheckPermission permission={'withdraw-wallet'}>
                        <Button onClick={() => this.handleOnClick()}>Withdraw Wallat Amount</Button>
                      </CheckPermission>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-block">
                  <div className="dt-responsive table-responsive">
                    <MUIDataTable
                      title={'History'}
                      className="table-responsive"
                      data={this.state.walletHistoryList}
                      columns={columns}
                      options={options}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          open={this.state.withdrawalModal}
          onClose={() => {
            this.setState({ withdrawalModal: false })
          }}
          center
        >
          <WithdrawModel
            walletAmount={this.state.nonExpirableWalletAmount || '0'}
            processWithdrawal={this.processWithdrawal}
          ></WithdrawModel>
        </Modal>
      </>
    )
  }
}

export default WalletHistory
